module.exports = __webpack_public_path__ + "assets/images/albom9.b4b3ec32.jpg";